<template>
  <div class="job-list-page">
    <header-component></header-component>
    <div class="jlp-tabs">
      <div
        :class="{
          'item': true,
          'active': i === nowIndex
        }"
        @click="changeListType(e,i)"
        v-for="(e,i) in tabsList"
        :key="i">
          {{ e.name }}
        <div v-if="e.num != 0" class="num">{{ e.num }}</div>
      </div>
    </div>
    <div class="jlp-content" v-loading="listLoading">
      <div class="jc-select-box">
        <el-select v-model="matchValue" @change="getList()" v-if="nowIndex == 0">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <div v-else></div>
        <div class="leapin-primary-huge-button ob-small" @click="clearSearchParmas()">Clear All</div>
      </div>

      <div class="jc-tags-box">
        <div v-for="(e,i) in tagsList" :key="i" class="leapin-tags leapin-purple">
          {{ e }}
        </div>
        <div class="filter" @click="showFilters()">
          Filters
          <span v-if="tagsList.length > 0">({{ total }})</span>
        </div>
      </div>
      <!-- 职位列表 -->
       <div class="jc-jobs-box" ref="scrollableDiv" @scroll="handleScroll">
        <jobs-list-item :matchValue="matchValue" :jobList="jobList" @refreshJobList="refreshJobList"></jobs-list-item>
       </div>
    </div>

    <!-- 搜索条件筛选抽屉 -->
    <el-drawer
      title="Filters"
      size="40%"
      :visible.sync="drawerShowFalg"
      :direction="direction">
      <div class="job-filter-page">
        <div class="leapin-air-title"><img :src="linkAir" />Basic Job Criteria</div>
          
        <el-form ref="filterForm" :model="filterForm" label-position="top">
          <el-form-item label="Job Title">
            <el-input v-model="filterForm.job_title"></el-input>
          </el-form-item>
          <el-form-item label="Job Type">
            <!-- 职位类型 -->
            <el-checkbox-group v-model="filterForm.job_type">
              <el-row :gutter="30">
                <el-col :span="12"><el-checkbox label="0" value="0">Full-time</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="1" value="1">Part-time</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="2" value="2">Intership</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="3" value="3">Contract</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="4" value="4">Freelance</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="5" value="5">Other</el-checkbox></el-col>
              </el-row>
            </el-checkbox-group>
          </el-form-item>
          <!-- 办公形式 -->
          <el-form-item label="Work Model">
            <el-checkbox-group v-model="filterForm.office_type">
              <el-row :gutter="30">
                <el-col :span="12"><el-checkbox label="0" name="0">Onsite</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="1" name="1">Remote</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="2" name="2">Hybrid</el-checkbox></el-col>
              </el-row>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="Location">
            <el-cascader
              @change="handleChange"
              v-model="locationValue"
              :props="{ value: 'label_en', label: 'label_en' }"
              :options="locationList">
            </el-cascader>
          </el-form-item>
          <!-- <el-form-item label="Experience Level">
            <el-checkbox-group v-model="filterForm.Level">
              <el-row :gutter="30">
                <el-col :span="12"><el-checkbox label="Intern Level" name="1"></el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="Entry Level" name="2"></el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="Mid Level" name="3"></el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="Senior Level" name="4"></el-checkbox></el-col>
              </el-row>
            </el-checkbox-group>
          </el-form-item> -->
          <el-form-item label="Experience (Year)">
            <el-slider
              v-model="filterForm.experience"
              range
              show-stops
              :max="50">
            </el-slider>
          </el-form-item>
          <el-form-item label="Company Stage">
            <el-checkbox-group v-model="filterForm.company_stage">
              <el-row :gutter="30">
                <el-col :span="12"><el-checkbox label="0" value="0">Early Stage</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="1" value="1">Growth Stage</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="2" value="2">Late Stage</el-checkbox></el-col>
                <el-col :span="12"><el-checkbox label="3" value="3">Pubilc Company</el-checkbox></el-col>
              </el-row>
            </el-checkbox-group>
          </el-form-item>

        </el-form>
        
        <div class="jfp-footer">
          <div class="leapin-short-defalut-button but" @click="Cancel">Cancel</div>
          <div class="leapin-short-primary-button but" @click="onSubmit">Confirm</div>
        </div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import { throttle } from 'lodash';
import { getJobsList } from '@/services/jobs'
import { addressList } from "@/services/address.js";
export default {
  components: {
    HeaderComponent: () => import('@/components/header/Header.vue'),
    JobsListItem: () => import('@/views/Jobs/listItem.vue'),
    // JobsFilter: () => import('@/views/Jobs/components/filter.vue')
  },
  name: 'Jobs',
  data() {
    return {
      locationValue: '',
      locationList: [],
      linkAir: require('@/assets/svgs/link-air.svg'),
      filterForm: {
        job_title: '', // 职位名称
        job_type: [], // 职位类型
        office_type: [],
        location: '',// 工作地点
        company_stage: [], // 公司阶段
        experience: [0,0], // 经验要求
      },
      pageNum: 1, // 当前页码
      listLoading: false,
      markType: 0, // int 标记类型 0-recommend 1-like 2-applied 3-collected 4-unlike
      // 职位列表搜索参数
      searchParams: {
        job_title: '', // 职位名称
        job_type: [], // 职位类型
        office_type: [],
        location: '',// 工作地点
        company_stage: [], // 公司阶段
        experience: [0,0], // 经验要求
      }, 
      jobList: [],
      direction: 'rtl',
      drawerShowFalg: false,
      tagsList: [],
      options: [
        {
          value: 'match_degree',
          label: 'Top Matched'
        }, 
        {
          value: 'create_time',
          label: 'Most Recent'
        },
      ],
      matchValue: 'create_time',
      nowIndex: 0,
      tabsList: [
        { name: 'Recommended', num: 0,value: 0 },
        { name: 'Like', num: 0, value: 1 },
        { name: 'Applied', num: 0, value: 2 },
      ],
      jobTypeList: [
        { value: 0, name: 'Full-time' },
        { value: 1, name: 'Part-time' },
        { value: 2, name: 'Internship' },
        { value: 3, name: 'Contract' },
        { value: 4, name: 'Temporary' },
        { value: 5, name: 'Other' },
      ],
      companyStageList: [
        { value: 0, name: 'Early Stage' },
        { value: 1, name: 'Growth Stage' },
        { value: 2, name: 'Late Stage' },
        { value: 3, name: 'Pubilc Company' },
      ],
      officeTypeList: [
        { value: 0, name: 'Onsite' },
        { value: 1, name: 'Remote' },
        { value: 2, name: 'Hybrid' },
      ]
    }
  },
  mounted () {
    this.matchValue = this.$route.query.type == 1 ? 'match_degree' : 'create_time'
    this.getList()
    this.getAddressList()
    const scrollableElement = this.$refs.scrollableDiv;
    scrollableElement.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    // filter ---function
    onSubmit() {
      //this.$emit('changeSearchPramas', this.filterForm);
      this.changeSearchPramas(this.filterForm)
    },
    Cancel() {
      //this.$emit('close');
      this.closeDrawer()
    },
    // 获取地址列表
    getAddressList() {
      addressList({page:1,page_size:100}).then(res => {
        this.locationList = res.data.results
      })
    },
    handleChange(value) {
      this.filterForm.location = value.join('/');
    },
    // filter ---function

    loadMore() {
      // 加载更多的逻辑...
      //console.log('Loading more items...');
      if (this.jobList.length >= this.total) {
        return;
      }
      this.pageNum++
      this.getList()
    },
    handleScroll: throttle(function() {
      const scrollableElement = this.$refs.scrollableDiv;
      if (scrollableElement.scrollHeight - scrollableElement.scrollTop === scrollableElement.clientHeight) {
        // 触发加载更多
        this.loadMore();
      }
    }, 500),// 节流函数，200ms 内最多执行一次
    changeListType (e,i) {
      this.nowIndex = i
      this.markType = e.value
      this.pageNum = 1
      this.getList()
    },
    // 清空搜索参数
    clearSearchParmas () {
      this.filterForm = {
        job_title: '', // 职位名称
        job_type: [], // 职位类型
        office_type: [],
        location: '',// 工作地点
        company_stage: [], // 公司阶段
        experience: [0,0], // 经验要求
      }
      this.searchParams = {
        job_title: '', // 职位名称
        job_type: [], // 职位类型
        office_type: [],
        location: '',// 工作地点
        company_stage: [], // 公司阶段
        experience: [0,0], // 经验要求
      }
      this.tagsList = []
      this.pageNum = 1
      this.getList()
    },
    // 改变搜索参数
    changeSearchPramas (params) {
      this.searchParams = JSON.parse(JSON.stringify(params))
      console.log('params', JSON.stringify(params))
      //处理展示的标签tags
      this.handleSearchTags(params)
      this.drawerShowFalg = false
      this.pageNum = 1
      this.getList();
    },
    //处理展示的标签tags
    handleSearchTags (obj) {
      this.tagsList = []
      let info = JSON.parse(JSON.stringify(obj))
      for (let i in info) {
        if (info[i].length > 0) {
          if (i === 'job_title' && info[i] != '') {
            this.tagsList.push(info[i])
          }
          if (i === 'job_type') {
            info[i] = info[i].map(e => {
              this.tagsList.push(this.jobTypeList.find(item => item.value == e).name)
            })
          }
          if (i === 'location' && info[i] != '') {
            this.tagsList.push(info[i])
          }
          if (i === 'company_stage') {
            info[i] = info[i].map(e => {
              this.tagsList.push(this.companyStageList.find(item => item.value == e).name)
            })
          }
          if (i === 'office_type') {
            info[i] = info[i].map(e => {
              this.tagsList.push(this.officeTypeList.find(item => item.value == e).name)
            })
          }
          if (i === 'experience' && JSON.stringify(info[i]) != JSON.stringify([0,0])) {
            this.tagsList.push(info[i].join('-') + ' years exp')
          }
        }
      }
    },
    refreshJobList () {
      this.pageNum = 1
      this.getList();
    },
    // 获取职位列表
    getList() {
      let params = JSON.parse(JSON.stringify(this.searchParams))
      params.job_type = params.job_type.length > 0 ? params.job_type.join(',') : ''
      params.company_stage = params.company_stage.length > 0 ? params.company_stage.join(',') : ''
      params.office_type = params.office_type.length > 0 ? params.office_type.join(',') : ''
      params.experience = params.experience[0] != 0 && params.experience[1] != 0 ? params.experience.join(',') : ''
      params.mark_type = this.markType
      params.ordering = this.nowIndex == 1 ? 'fix_time' : this.matchValue
      params.page = this.pageNum
      params.page_size = 10

      this.listLoading = true
      getJobsList(params).then(res => {
        this.listLoading = false
        if (res.code === 0) {
          this.total = res.data.count
          this.jobList = this.pageNum == 1 ? res.data.results : this.jobList.concat(res.data.results)
          if (this.maxNum) { // 如果有最大显示数量
            this.jobList = this.jobList.slice(0, this.maxNum)
          }
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    showFilters () {
      this.drawerShowFalg = true
    },
    closeDrawer () {
      this.drawerShowFalg = false
    }
  },
  beforeDestroy() {
    const scrollableElement = this.$refs.scrollableDiv;
    scrollableElement.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped lang="scss">
.job-list-page {
  background: linear-gradient(90deg, #F9ECEF 16.29%, #F2F0FB 51.61%, #F7F6FD 83.83%);
  height: 100vh;
  position: relative;
  overflow-x: hidden;
  overflow-y: scroll;
  .jlp-tabs {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0 32px;
    position: relative;
    margin: 0 auto;
    top: 100px;
    color: #000;
    font-family: "PingFang SC";
    font-size: 20px;
    font-weight: 600;
    .item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0 8px;
      .num {
        padding: 6px 11px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "PingFang SC";
        font-size: 12px;
        border-radius: 100px;
        color: #FFF;
        background: #6E62E5;
      }
    }
    .active {
      color: #FFF !important;
      border-radius: 100px;
      padding: 8px 12px;
      background: #6E62E5 !important;
      .num {
        color: #6E62E5 !important;
        background: #FFF !important;

      }
    }
  }
  .jlp-content {
    max-width: 1200px;
    position: relative;
    margin: 0 auto;
    top: 120px;
    background: #fff;
    border-radius: 20px;
    padding: 32px;
    .jc-select-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0 20px;
      padding-bottom: 12px;
      border-bottom: 1px solid #E6E8F0;
    }
    .jc-tags-box {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      padding-top: 12px;
      margin-bottom: 15px;
      .filter {
        display: flex;
        height: 22px;
        padding: 5px 16px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 100px;
        background: #6E62E5;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .jc-jobs-box {
      height: calc(100vh - 350px);
      overflow-x: hidden;
      overflow-y: scroll;
    }
  }
}
</style>
<style lang="scss">
.job-list-page {
  .el-select .el-input__inner {
    color: #6E62E5;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    border-radius: 100px;
    border: 1px solid #6E62E5;
  }
  /* 针对特定类名的样式 */
  .el-input__inner::placeholder {
    color: #6E62E5; /* 占位符字体颜色 */
  }
  .el-select .el-input .el-select__caret {
    color: #6E62E5;
    top: 20px
  }
}
.job-filter-page {
  padding: 20px;
  position: relative;
  //height: calc(100vh - 80px);
  overflow-x: hidden;
  overflow-y: scroll;
  margin-bottom: 50px;
  .jfp-footer {
    width: -webkit-fill-available;
    position: fixed;
    z-index: 9;
    bottom: 0;
    padding: 20px 20px 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0 20px;
    background: #fff;
    .but {
      padding: 4px 16px !important;
    }
  }
}
</style>
